import React, { ReactElement } from 'react'
import { Flex } from 'theme-ui'
import { Svg } from 'ui'
import GreenCheckmarkIcon from 'images/plans/green-checkmark.svg'
import GreyCheckmarkIcon from 'images/plans/grey-checkmark.svg'
import InfoIcon from 'images/plans/info-icon.svg'
import IconWithTippyPopup from 'ui/IconWithTippyPopup'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'

interface FeatureProps {
  type?: string
  name: string | ReactElement
  tooltip?: string
}
function Feature({ name, tooltip, type }: FeatureProps): ReactElement {
  return (
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Flex sx={{ alignItems: 'center' }}>
        <Svg
          svg={type ? GreenCheckmarkIcon : GreyCheckmarkIcon}
          sx={{ width: '2.4rem', height: '2.4rem' }}
          descriptiveText={type ? 'Feature included' : 'Feature not included'}
        />
        <TextWithBreakpointVariant
          variant={['size14Weight500Line138', 'size17Weight500Line138']}
          sx={{
            ml: ['0.8rem', '1.6rem'],
            color: type ? 'greenApple' : 'aliceBlue70',
          }}
        >
          {name}
        </TextWithBreakpointVariant>
      </Flex>
      {tooltip && (
        <Flex
          sx={{
            alignItems: 'center',
            ml: '0.4rem',
          }}
        >
          <IconWithTippyPopup
            content={tooltip}
            ariaLabel={tooltip}
            svg={InfoIcon}
            descriptiveText="Feature information"
            sx={{
              width: '1.6rem',
              height: '1.6rem',
            }}
            sxButton={{
              ':hover': {
                '& > svg g': {
                  opacity: 1,
                },
              },
            }}
            maxWidth={280}
          />
        </Flex>
      )}
    </Flex>
  )
}
export default Feature
